import React, { Fragment, useState } from 'react'
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { DeleteTwoTone, EditTwoTone } from '@mui/icons-material'
import { BsPlusLg } from 'react-icons/bs'
import VehiclesServices from 'app/apis/Vehicles/VehiclesServices'
import colors from 'app/styles/colors'
import { ErrorToaster, SuccessToaster } from 'app/components/Toaster/Toaster'
import { Loading } from 'app/assets/Images'
import SimpleDialog from 'app/components/Dialog/ValidationDialog'
import VehicleColorDialog from 'app/components/Dialog/VehicleDialogs/VehicleColorDialog'

function VehicleColors({ getVehicleColors, vehicleColors }) {

  // *For Alert Dialog
  const [alertDialog, setAlertDialog] = useState(false);

  // *For Delete
  const [deleteId, setDeleteId] = useState();

  // *For Dialog Box
  const [openDialog, setOpenDialog] = useState(false);

  // *For Update Data
  const [updateData, setUpdateData] = useState();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Add Vehicle Type
  const createVehicleColor = async (obj) => {
    setLoading(true)
    try {
      const { status, responseCode, message } = await VehiclesServices.createVehicleColor(obj)
      if (status === true && responseCode === 200) {
        getVehicleColors()
        SuccessToaster(message)
        onClose()
      }
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  // *For Update Vehicle Color
  const updateVehicleColor = async (obj) => {
    setLoading(true)
    try {
      const { status, responseCode, message } = await VehiclesServices.updateVehicleColor(obj)
      if (status === true && responseCode === 200) {
        getVehicleColors()
        SuccessToaster(message)
        onClose()
      }
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  // *For Delete Vehicle Color
  const deleteVehicleColor = async () => {
    try {
      const { status, responseCode, message } = await VehiclesServices.deleteVehicleColor(deleteId)
      if (status === true && responseCode === 200) {
        getVehicleColors()
        SuccessToaster(message)
        setAlertDialog(false)
      }
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const onClose = () => {
    setUpdateData('')
    setOpenDialog(false)
  }

  return (
    <Fragment>

      {/* ======= Alert Dialog =====  */}
      <SimpleDialog open={alertDialog} onClose={() => setAlertDialog(false)} title={"Are you sure to remove this?"} action={() => deleteVehicleColor()} />

      {/* ========== Vehicle Color Dialog ========== */}
      <VehicleColorDialog
        open={openDialog}
        close={() => onClose()}
        add={(data) => createVehicleColor(data)}
        update={(data) => updateVehicleColor(data)}
        loading={loading}
        updateData={updateData}
      />

      {vehicleColors.length > 0 ? (
        <Grid container spacing={2} >
          {vehicleColors.map((element, index) => (
            <Grid item key={index} xs={3}>
              <Box sx={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                bgcolor: element.hex_code, p: 2, borderRadius: "12px",
                overflow: "hidden", position: "relative",
                boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px"
              }}>
                <Typography variant="body1" fontWeight="bold" sx={{
                  color: element.color?.toLowerCase() === "white" ? colors.black : colors.white, zIndex: 1
                }}>
                  {element.color}
                </Typography>
                <Box>
                  <Tooltip title="Edit" >
                    <IconButton onClick={() => { setUpdateData(element); setOpenDialog(true) }}>
                      <EditTwoTone sx={{
                        fontSize: "20px",
                        color: element.color?.toLowerCase() === "white" ? colors.black : colors.white
                      }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete" >
                    <IconButton onClick={() => { setDeleteId(element.color); setAlertDialog(true) }} >
                      <DeleteTwoTone sx={{
                        fontSize: "20px",
                        color: element.color?.toLowerCase() === "white" ? colors.black : colors.white
                      }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Grid>
          ))}
          <Grid item xs={1.5}>
            <Box
              onClick={() => setOpenDialog(true)}
              sx={{
                bgcolor: colors.primaryLight, p: 2, borderRadius: "12px", height: 0.55,
                display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer"
              }}>
              <BsPlusLg color={colors.primaryDark} size={25} />
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Box sx={{ width: 1, textAlign: "center", pt: 5 }}>
          <Loading />
        </Box>
      )}

    </Fragment>
  )
}

export default VehicleColors